module.exports = __webpack_public_path__ + "img/03.de98841a.jpg";